export const GET_UPDATEMSG_STATUS = 'GET_UPDATEMSG_STATUS'; // 新获取上传解密状态
export const GET_BIDBYID_STATUS = 'GET_BIDBYID_STATUS'; // 新获取开标信息状态
export const GET_EVALBID_ALLEND = 'GET_EVALBID_ALLEND'; // 获取一阶段评标是否全部结束
export const GET_OPENBID_STAGE = 'GET_OPENBID_STAGE'; // 新获取开标阶段
export const GET_BIDDERDECRYPT_STATUS = 'GET_BIDDERDECRYPT_STATUS'; // 解密
export const GET_BIDDERPARSE_STATUS = 'GET_BIDDERPARSE_STATUS'; // 解析
export const GET_DIERYPTEND_STATUS = 'GET_DIERYPTEND_STATUS'; // 结束解密
export const GET_DECRYPTENDTIME_STATUS = 'GET_DECRYPTENDTIME_STATUS'; // 結束解密狀態
export const GET_DIERYPTSTART_STATUS = 'GET_DIERYPTSTART_STATUS'; // 发起解密
export const GET_DECRYPTSTARTTIME_STATUS = 'GET_DECRYPTSTARTTIME_STATUS'; // 发起解密狀態
export const GET_OPENBIDTWO_STATUS = 'GET_OPENBIDTWO_STATUS'; // 获取单阶段和第一阶段状态
export const GET_OPENBIDTWOTWO_STATUS = 'GET_OPENBIDTWOTWO_STATUS'; // 获取多阶段第二阶段状态
export const GET_BIDIDINSTAGES_STATUS = 'GET_BIDIDINSTAGES_STATUS'; // 获取bidid集合
export const GET_BUDIDINOBJ_STATUS = 'GET_BUDIDINOBJ_STATUS'; // 获取bidid对象
export const GET_BIDIDS_STATUS = 'GET_BIDIDS_STATUS'; // 获取bidid对象
export const GET_BIDIDONE_STATUS = 'GET_BIDIDONE_STATUS'; // 获取bididOne
export const GET_BIDIDTWO_STATUS = 'GET_BIDIDTWO_STATUS'; // 获取bididTwo
export const GET_COEFFIENTONE_STATUS = 'GET_COEFFIENTONE_STATUS'; // 一阶段系数抽取
export const GET_COEFFIENTTWO_STATUS = 'GET_COEFFIENTTWO_STATUS'; // 二阶段系数抽取
export const GET_COMPANYLIST_STATUS = 'GET_COMPANYLIST_STATUS'; // 意義投標單位列表
export const GET_COMPANYITEM_STATUS = 'GET_COMPANYITEM_STATUS'; // 意義投標单位条目
export const GET_ENDDISSENT_STATUS = 'GET_ENDDISSENT_STATUS'; // 意義結束
export const GET_ENDDISSENTALL_STATUS = 'GET_ENDDISSENTALL_STATUS'; // 意義全部結束
export const GET_DISSENT_MESSAGE = 'GET_DISSENT_MESSAGE'; // 意義已读未读
export const GET_DISSENTRED_ROLL = 'GET_DISSENTRED_ROLL'; // 意義全部消息體
export const GET_ALL_ROOM = 'GET_ALL_ROOM'; // 意義全部消息推送
export const GET_AllDISSENTRIGHT_STATUS = 'GET_AllDISSENTRIGHT_STATUS'; // 全局跨阶段异议状态
export const GET_GETTHREEBID_STATUS = 'GET_GETTHREEBID_STATUS'; // 小于等于三家流标
export const GET_FAILBIDTIPS_STATUS = 'GET_FAILBIDTIPS_STATUS'; // 小于等于三家流标提示时刻
export const GET_BIDINDEX_STATUS = 'GET_BIDINDEX_STATUS'; // 获取当前标段下标
export const GET_UPDATEPUBBIDDER_STATUS = 'GET_UPDATEPUBBIDDER_STATUS'; // 获取当前标段下标
export const GET_MENU_STATUS = 'GET_MENU_STATUS';
export const CHANGE_SCREEN_WIDTH = 'CHANGE_SCREEN_WIDTH';
export const GET_LOGIN_STATUS = 'GET_LOGIN_STATUS';
export const GET_MAIN_NAME = 'GET_MAIN_NAME';
export const GET_BID_STATUS = 'GET_BID_STATUS';
export const GET_BIDID_STATUS = 'GET_BIDID_STATUS';
export const GET_BIDID_TWO_STATUS = 'GET_BIDID_TWO_STATUS';
export const GET_SOCKET_STATUS = 'GET_SOCKET_STATUS';
export const GET_SOCKET_TYPE = 'GET_SOCKET_TYPE';
export const GET_SOCKET_MSG = 'GET_SOCKET_MSG';
export const GET_DISSENT_MSG = 'GET_DISSENT_MSG';
export const GET_CHECK_SEND_MSG = 'GET_CHECK_SEND_MSG';
export const GET_DISSENT_COUNT = 'GET_DISSENT_COUNT';
export const GET_DISSENT_AGREE = 'GET_DISSENT_AGREE';
export const GET_DISSENT_LIST = 'GET_DISSENT_LIST';
export const GET_DISSENT_ROOM = 'GET_DISSENT_ROOM';
export const GET_DISSENT_NUM = 'GET_DISSENT_NUM';
export const GET_DISSENT_INIT = 'GET_DISSENT_INIT';
export const GET_DISSENT_TIME = 'GET_DISSENT_TIME';
export const GET_ENDORTIME_STATUS = 'GET_ENDORTIME_STATUS';
export const GET_SERVERTIME_STATUS = 'GET_SERVERTIME_STATUS';
export const GET_ISOUT_STATUS = 'GET_ISOUT_STATUS';
export const GET_ISSTOP_STATUS = 'GET_ISSTOP_STATUS';
export const GET_FINISHDECRYPT_STATUS = 'GET_FINISHDECRYPT_STATUS';
export const GET_STARTTIME_STATUS = 'GET_STARTTIME_STATUS';
export const GET_READBID_STATUS = 'GET_READBID_STATUS';
export const GET_PARAM_EXTRACT = 'GET_PARAM_EXTRACT';
export const GET_READ_BID = 'GET_READ_BID';
export const GET_PUB_RESULT = 'GET_PUB_RESULT';
export const CAL_BASEPRICE_FINISH = 'CAL_BASEPRICE_FINISH';
export const CAL_BASEPRICE_CONFIRM = 'CAL_BASEPRICE_CONFIRM';
export const GET_BIDSECTION_STATUS = 'GET_BIDSECTION_STATUS';
export const GET_BIDSECTION_STATUS_INFOS = 'GET_BIDSECTION_STATUS_INFOS';
export const GET_DISSENTSECTION_STATUS = 'GET_DISSENTSECTION_STATUS';
export const GET_DISSENTSECTION_STATUS_INFOS =
  'GET_DISSENTSECTION_STATUS_INFOS';
export const GET_STAGE_STATUS = 'GET_STAGE_STATUS';
export const GET_MENU_TRUE_STATUS = 'GET_MENU_TRUE_STATUS';
export const GET_MENU_CURRENT_STATUS = 'GET_MENU_CURRENT_STATUS';
export const GET_SOCKET_PARAMS = 'GET_SOCKET_PARAMS'; // 多页签全局推送
export const GET_CANDIDATESTART = 'GET_CANDIDATESTART'; // 入围推送
export const GET_ISREFRESHALTERNATEFLAG = 'GET_ISREFRESHALTERNATEFLAG'; // 入围推送
export const GET_GLDET_CA = 'GET_GLDET_CA'; // 广联达E投CA返回结果
export const GET_GLDET_BACK_RESULT_CA = 'GET_GLDET_BACK_RESULT_CA'; // 广联达E投CA解密成功返回结果
